export default {"src":"/_next/static/media/cutlery_white.40e9cef1.svg","height":20,"width":13,"blurWidth":0,"blurHeight":0};